export default __webpack_public_path__ + "static/media/female_blue.b28ac786.svg";